import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.less'],
  providers: [NgbDatepickerConfig]
})
export class DatepickerComponent implements OnInit {


	model: NgbDateStruct;
  	dateString: string;
  	minDate: NgbDateStruct;
	maxDate: NgbDateStruct;
	currentDate: any;

  	constructor(
    	private ngbDateParserFormatter: NgbDateParserFormatter,
	  	private ngbDatepickerConfig: NgbDatepickerConfig,
		
  	) {

		  this.model = this.setDefaultDate();
	  }

  	@Input() minDateSet:string;
    @Input() maxDateSet:string;
  	@Input() label:string;
  	@Input() required:string;
  	@Input() type:string;


	@Output() dateChange = new EventEmitter();

	dateType:string;



  	ngOnInit() {

	  	 	
  	 	if(this.minDateSet){
  	 		this.minDate = this.setDefaultDate();
  	 	}
       if(this.maxDateSet){
         this.createMaxDate();
       }
    	this.onSelectDate(this.model);

  	}

    onSelectDate(date: NgbDateStruct){
    	//send date to parent
    	if(!this.type){
    		var type = 'date';
    	}else{
    		var type = this.type+'Date';
    	}
    	if(!this.required){
    		var req = false;
    	}else{
    		var req = true;
    	}
    	this.dateChange.emit({date,type,req});
	    if (date != null) {
	            this.model = date;   //needed for first time around due to ngModel not binding during ngOnInit call. Seems like a bug in ng2.
	            this.dateString = this.ngbDateParserFormatter.format(date);
	        }
	  }
  
  	setDefaultDate(): NgbDateStruct {
        var startDate = new Date();
        let startYear = startDate.getFullYear().toString();
        let startMonth = startDate.getMonth() + 1; 
		let startDay = startDate.getDate();
		
        return this.ngbDateParserFormatter.parse(startYear + "-" + startMonth.toString() + "-" + startDay);
	}


   createMaxDate(){
         var startDate = new Date();
        let startYear = startDate.getFullYear();
        let startMonth = startDate.getMonth() + 1; 
        let startDay = startDate.getDate();

       this.ngbDatepickerConfig.maxDate = {year: startYear, month: startMonth, day:startDay}


  }

}




// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/cycler/apollo-admin/src/src/app/datepicker/datepicker.component.ts